import { Component, OnInit } from "@angular/core";
import { LangDefinition, TranslocoService } from "@ngneat/transloco";
import { GeolocationService } from "../../services/geolocation.service";

@Component({
    selector: 'app-language-selector',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {
    public languages: { lang: string | LangDefinition, name: any }[] = []
    public selectedLanguage: string;

    constructor(
        private translocoSvc: TranslocoService,
        private geoService: GeolocationService
    ) {
        this.translocoSvc.getAvailableLangs().forEach(lang => {
            this.languages.push({
                lang,
                name: lang === 'es' ? '🇪🇸' : lang === "en" ? "🇬🇧" : "🇫🇷"
            })
        });
    }

    ngOnInit(): void {
        const storedLang = localStorage.getItem('lang');
        
        if (storedLang) {
            this.selectedLanguage = storedLang;
            this.translocoSvc.setActiveLang(storedLang);
        } else {
            this.geoService.getUserCountry().subscribe(data => {
                let defaultLang = 'en';
                if (data.country === 'ES') {
                    defaultLang = 'es';
                } else if (data.country === 'FR') {
                    defaultLang = 'fr';
                }
                this.selectedLanguage = defaultLang;
                this.translocoSvc.setActiveLang(defaultLang);
                localStorage.setItem('lang', defaultLang);
            });
        }
    }

    onLanguageChange(event: Event) {
        const lang = (event.target as HTMLSelectElement).value;
        this.selectedLanguage = lang;
        this.translocoSvc.setActiveLang(lang);
        localStorage.setItem('lang', lang);
    }
}